import { render, staticRenderFns } from "./groups-side-bar-group.vue?vue&type=template&id=ead20de8&scoped=true&"
import script from "./groups-side-bar-group.vue?vue&type=script&lang=js&"
export * from "./groups-side-bar-group.vue?vue&type=script&lang=js&"
import style0 from "./groups-side-bar-group.vue?vue&type=style&index=0&id=ead20de8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead20de8",
  null
  
)

export default component.exports